import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';


function WithdrawRequestReceipt(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};


	const opData = props.data;
	const operationTitle = getLabel('retail.withdraw_request.title');
	const amount = getCurrencyValue(opData.operationAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			<div>{getLabel('retail.date_time') + ": " + getFormattedTimestamp()}</div>
			<div>{getLabel('retail.shop_pvend') + ": " + opData.operator.pvend + "/" + opData.operator.shopDescr}</div>
			<div>{getLabel('retail.terminal_number') + ": " + opData.operator.idTag}</div>
			<div>{getLabel('retail.operator') + ": " + opData.operator.operatorUsername}</div>
			<hr className="hr-line" />
			<div className="centerText">{getLabel('retail.amount') + ": " + amount}</div>
			<div className="centerText">{getLabel('retail.withdraw_request.owner') + ": " + opData.owner}</div>
			<div className="centerText">{getLabel('retail.withdraw_request.causale') + ": " + opData.causale}</div>
			<div className="centerText">{getLabel('retail.withdraw_request.receipt.operation_code') + ": " + opData.object}</div>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default WithdrawRequestReceipt;